import { render, staticRenderFns } from "./ResendLink.vue?vue&type=template&id=452704aa&"
import script from "./ResendLink.vue?vue&type=script&lang=js&"
export * from "./ResendLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports